/**
 * 环境区分的title文件
 * window.$t("i18n_BOE")
 */

const ENV_TITLES = {
  dev: "BOE_DEV",
  test: "BOE_QAS",
  master: "",
};
let ENV;
if (location.host.includes("dev")) {
  ENV="dev"
} else if (location.host.includes("qas")) {
  ENV="test"
} else if(location.host.includes("prd")) {
  ENV="master"
}

const localTitle = {
  en: "BOE SRM",
  zh_cn: ENV ? ENV_TITLES[ENV] : "BOE SRM", //京东方SRM
};
const lang = window.localStorage.getItem("localeLanguage");
export const ENV_TITLE = localTitle[lang];
